import SeasonSelect from "@/components/SeasonSelect.vue";
import EmployeeSelectV2 from "@/components/EmployeeSelectV2.vue";
import AbsenceSelect from "@/components/AbsenceSelect.vue";
import { getSeason } from "../utils/utilApi";
import moment from "moment";
import { absenceTable } from "../data/AttendanceManage";
import { post } from "../utils/request";
import { ElMessage } from "element-plus";


export default {
  components: { SeasonSelect, EmployeeSelectV2, AbsenceSelect },
  data() {
    return {
      showable: {
        absenceForm: false,
      },
      disable: {
        addItemBtn: false,
      },
      searchKeyWord: "",
      departmentId: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentId,
      // 分页控制
      currentPage: 1,
      pagesize: 10,
      absenceList: [],
      absenceTable: [],
      year: moment().format("YYYY"),
      season: getSeason(),
      absenceForm: {
        userId: "",
        name: "",
        departmentName: "",
        type: "",
        beginDate: "",
        endDate: "",
        duration: "",
        minusScore: "",
        reason: "",
        remarks: ""
      }
    };
  },
  name: "AttendanceManage",
  methods: {
    // 切换每页显示数据
    handleSizeChange(val) {
      this.pagesize = val;
      // console.log(`每页 ${val} 条`);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
    },
    formatter(row, column) {
      if (column.property == 'name') {
        return row.username;
      } else {
        return row[column.property];
      }
    },
    handleEdit(index, row) {
      this.absenceForm = this.$options.data().absenceForm;
      this.absenceForm = row;
      this.disable.addItemBtn = true;
      this.showable.absenceForm = true;
    },
    handleAddBtn() {
      this.absenceForm = this.$options.data().absenceForm;
      this.disable.addItemBtn = false;
      this.showable.absenceForm = true;
    },
    doCancel() {
      this.showable.absenceForm = false;
    },
    /**
     * @description 新增考勤异常记录页面
     * @function POST /record/add
     * 
     * @param {int} userId 用户id
     * @param {String} type 缺勤类型
     * @param {Date} beginDate 开始时间
     * @param {Date} endDate 结束时间
     * @param {int} duration 时长(天)
     * @param {int} minusScore 扣分值
     * @param {String} reason 事由
     * @param {String} remarks 备注
     */
    addRecord() {
      if (parseInt(this.absenceForm.minusScore) > 5) {
        ElMessage.warning("扣分不能超过5分", {
          duration: 3 * 1000,
        });
        return;
      }
      post('/record/add', JSON.stringify(this.absenceForm)).then(res => {
        if (res.code == 200) {
          this.searchRecord();
          this.showable.absenceForm = false;
        }
      });
    },
    /**
     * @description 查询departmentId下的考勤异常记录。科室长和局级管理都实现这个功能。
     * @function POST /record/search
     * @param {int} year 年度
     * @param {String} season 季度
     * @param {int} departmentId 部门/科室ID
     * 
     * @returns {Array} absenceList，其中每一项元素的属性除了user_record表中的每一项，还有name用户姓名，departmentName部门名称
     */
    searchRecord() {
      let data = {
        year: this.year,
        season: this.season,
        departmentId: this.departmentId,
      };
      post('/record/search', JSON.stringify(data)).then(res => {
        if (res.code == 200) {
          this.absenceList = JSON.parse(res.data.absenceList);
        }
        if (res.code == 204) {
          this.absenceList = [];
        }
      });
    },
    /**
     * @description 删除考勤异常记录
     * @function POST /record/delete
     * @param {int} recordId 记录ID
     * 
     * @returns 删除成功
     */
    deleteRecord(index, row) {
      post('/record/delete', JSON.stringify({ recordId: row.recordId })).then(res => {
        if (res.code == 200) {
          this.absenceList.splice(index, 1);
        }
      });
    }
  },
  created() {
    this.absenceTable = absenceTable;
    this.searchRecord();
  },
  computed: {
    filteredData() {
      return this.absenceList.filter(data => !this.searchKeyWord || data.username.toLowerCase().includes(this.searchKeyWord.toLowerCase()) || data.departmentName.toLowerCase().includes(this.searchKeyWord.toLowerCase()))
    }
  },
  watch: {
    year() {
      this.searchRecord();
    },
    season() {
      this.searchRecord();
    }
  }
};